import axios from "axios";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { React } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "../Style.css";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { v4 as uuid } from "uuid";
import Footer from "./Footer";

import {
  fetchBusinessList,
  saveBusinessData,
  uploadMediaData,
  deleteData,
} from "../services/apiService";


const CompanyDetailUpdate = () => {
  const navigate = useNavigate();
  const [businessLogo, setBusinessLogo] = useState("Upload Your Business Logo");
  const [postImage, setPostImage] = useState("");
  const [fileName, setFileName] = useState("");

  const [companyId, setCompanyId] = useState("");
  /**
   * View Product or Service Details
   */
  const [show, setShow] = useState(false);
  const [productId, setProductId] = useState("");
  const [productName, setProductName] = useState("");
  const [productImage, setProductImage] = useState("");
  const [productDesc, setProductDesc] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    if (item != "") {
      setProductName(item.name);
      setProductId(item.productId);
      setProductImage(item.image);
      setProductDesc(item.desc);
    }
    setShow(true);
  };

  /**
   * Save/Add New Product
   */

  const [addProduct, setAddProduct] = useState(false);
  const [itemType, setItemType] = useState("");

  const saveProduct = () => {
    /* Validations */
    if (productName === "" || productDesc === "") {
      toast.error("Please specify name and description !");
      return false;
    }

    let productList;

    if (itemType === "Product") {
      productList = products;
    } else if (itemType === "Service") {
      productList = services;
    }

    productList.push({
      productId: uuid(),
      name: productName,
      desc: productDesc,
      image: productImage,
    });

    if (itemType === "Product") {
      setProducts(productList);
    } else if (itemType === "Service") {
      setServices(productList);
    }

    setProductName("");
    setProductDesc("");
    setProductImage("");
    setAddProduct(false);

    toast.success("Saved, successfully.");
  };

  /**
   * Update Product or Service
   */

  const [isUpdateProduct, setIsUpdateProduct] = useState(false);

  const handleUpdateProduct = (item) => {
    if (item != "") {
      setProductName(item.name);
      setProductId(item.productId);
      setProductImage(item.image);
      setProductDesc(item.desc);
    }
    setIsUpdateProduct(true);
  };
  const handleProductClose = () => {
    setIsUpdateProduct(false);
    setAddProduct(false);
  };

  var modules = {
    toolbar: [
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        { align: [] },
      ],
      [
        {
          color: [
            "#000000",
            "#e60000",
            "#ff9900",
            "#ffff00",
            "#008a00",
            "#0066cc",
            "#9933ff",
            "#ffffff",
            "#facccc",
            "#ffebcc",
            "#ffffcc",
            "#cce8cc",
            "#cce0f5",
            "#ebd6ff",
            "#bbbbbb",
            "#f06666",
            "#ffc266",
            "#ffff66",
            "#66b966",
            "#66a3e0",
            "#c285ff",
            "#888888",
            "#a10000",
            "#b26b00",
            "#b2b200",
            "#006100",
            "#0047b2",
            "#6b24b2",
            "#444444",
            "#5c0000",
            "#663d00",
            "#666600",
            "#003700",
            "#002966",
            "#3d1466",
            "custom-color",
          ],
        },
      ],
    ],
  };

  var formats = [
    "header",
    "height",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "color",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "size",
  ];

  const [pagesData, setPagesData] = useState({
    home: "",
    about: "",
    contact: "",
  });

  const handleProcedureContentChange = (content, page) => {
    if (page == "home") {
      pagesData.home = content;
      setHome(content);
    }

    if (page == "about-us") {
      pagesData.about = content;
      setAbout(content);
    }

    if (page == "contact") {
      pagesData.contact = content;
      setContactUs(content);
    }

    setPagesData(pagesData);
  };

  const { id } = useParams();
  const [companyDetail, setCompanyDetail] = useState({});

  const [contactNumber, setContactNumber] = useState("");
  const [language, setLanguage] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [contactPersonName, setContactPersonName] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [businessLogoInfo, setBusinessLogoInfo] = useState("");
  const [webPages, setWebPages] = useState([]);
  const [home, setHome] = useState("");
  const [about, setAbout] = useState("");
  const [contactUs, setContactUs] = useState("");
  const [offering, setOffering] = useState("");
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let payloadData = {
      language: language,
      websiteName: businessName,
      contactName: contactPersonName,
      contactNumber: contactNumber,
      email: businessEmail,
      logo: businessLogoInfo,
      webPages: webPages,
      homePageContent: home,
      aboutUsPageContent: about,
      reachToUs: contactUs,
      offering: offering,
      products: products,
      services: services,
    };
    try {
      const res = await saveBusinessData("api/v1/update?id=" + id, payloadData);
      if (res.success) {
        toast.success("Saved, Successfully.");
        navigate("/company-detail/" + id);
      } else if (!res.success) {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  /**
   * Delete Products or Service Record
   */

  const deleteRecord = async (pId, productType, productName) => {
    if (productType == "Product") {
      let restProductsAfterRemove = products.filter((i) => i.productId != pId);
      setProducts(restProductsAfterRemove);
      toast.success(
        productType + " - " + productName + " has deleted, Successfully."
      );
    }

    if (productType == "Service") {
      let restServicesAfterRemove = services.filter((i) => i.productId != pId);
      setServices(restServicesAfterRemove);
      toast.success(
        productType + " - " + productName + " has deleted, Successfully."
      );
    }
  };

  /**
   * View Details of a product or service
   */

  const getRecords = async () => {
    try {
      const res = await fetchBusinessList("api/v1/view?id=" + id);
      if (res.success) {
        let companyDetail = res.data;

        setCompanyId(companyDetail.id);
        setContactNumber(companyDetail.contactNumber);
        setLanguage(companyDetail.language);
        setBusinessName(companyDetail.websiteName);
        setContactPersonName(companyDetail.contactName);
        setBusinessEmail(companyDetail.emailId);
        setBusinessLogoInfo(companyDetail.logo);
        setWebPages(companyDetail.webPages);
        setHome(companyDetail.homePageContent);
        setAbout(companyDetail.aboutUsPageContent);
        setContactUs(companyDetail.reachToUs);
        setOffering(companyDetail.offering);
        setProducts(companyDetail.products);
        setServices(companyDetail.services);
      } else if (!res.success) {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  const handleToggle = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      let selectedWebPages = webPages;
      selectedWebPages.push(e.target.value);
      let s = new Set(selectedWebPages);
      let a1 = [...s];
      setWebPages(a1);
    } else {
      let selectedWebPages = webPages;
      const index = selectedWebPages.indexOf(e.target.value);
      selectedWebPages.splice(index, 1);
      let s = new Set(selectedWebPages);
      let a1 = [...s];
      setWebPages(a1);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOffering(value);
  };

  /**
   * Update Product
   */
  const updateProducts = () => {
    let updatedProductInfo = {
      productId: productId,
      name: productName,
      image: productImage,
      desc: productDesc,
    };

    let newProductList = products.filter(
      (p, index) => p.productId != productId
    );
    newProductList.push(updatedProductInfo);
    setProducts(newProductList);
    setIsUpdateProduct(false);
    toast.success("Saved, successfully.");
  };

  /* End of Uploading Product Images */

  const handleFileUpload = async (e, uploadType) => {
    const file = e.target.files[0];
    if (file != "" || file != null) {
      let isError = mediaValidationCheck(file);
      if (isError) {
        return false;
      }

      const formData = new FormData();
      formData.append("file", file);
      // make a POST request to the File Upload API with the FormData object and Rapid API headers

      try {
        const res = await uploadMediaData("api/v1/uploadMedia", formData);
        if (res.result) {
          toast.success("Uploaded, Successfully.");
          let logoDetails = res.data;

          if (uploadType == "logo") {
            setBusinessLogoInfo(logoDetails.imageUrl);
          } else if (uploadType == "productImage") {
            setProductImage(logoDetails.imageUrl);
          }

        } else if (!res.success) {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error("Failed to load data", error);
      }
    }
  };

  const mediaValidationCheck = (file) => {
    let isError = false;
    const fileSize = file.size / 1000;
    const allowedFileSize = ["1 MB"];
    if (fileSize > 1000) {
      toast.error(`File size must be ${allowedFileSize.join(", ")}`);
      isError = true;
    }

    const fileExtension = file.name.split(".").at(-1);
    const allowedFileTypes = ["png", "jpeg", "jpg", "gif"];
    if (!allowedFileTypes.includes(fileExtension)) {
      toast.error(
        `File does not support. Files type must be ${allowedFileTypes.join(
          ", "
        )}`
      );
      isError = true;
    }
    return isError;
  };

  /**
   * Deleting Media File
   */

  const handleFileDelete = async () => {
    setPostImage("");

    try {
      let mediaFileInfo = businessLogoInfo.split(".com/");
      const res = await deleteData(
        "api/v1/deleteMedia?file=" + mediaFileInfo[1]
      );
      setBusinessLogoInfo("");
      toast.success("Deleted, Successfully.");
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  useEffect(() => {
    getRecords();
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h2>Details - {businessName}</h2>
            </div>

            <div>
              {companyDetail != null && (
                <form onSubmit={handleSubmit}>
                  <table className="table table-border table-striped table-bordered">
                    <tbody>
                      <tr>
                        <td>Your Company Name</td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            value={businessName}
                            onChange={(e) => setBusinessName(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Language</td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            value={language}
                            readOnly
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Upload Logo </td>
                        <td>
                          <div className="row">
                            <div className="column">
                              <input
                                type="file"
                                label="Image"
                                name="myFile"
                                accept=".jpeg, .png, .jpg"
                                onChange={(e) => handleFileUpload(e, "logo")}
                              />
                            </div>
                            <div className="column">
                              {businessLogoInfo !== "" ? (
                                <div>
                                  <span>
                                    <img
                                      className="logo"
                                      src={businessLogoInfo}
                                      alt={businessName}
                                    />
                                  </span>

                                  <span>
                                    <input
                                      type="button"
                                      onClick={(e) => handleFileDelete()}
                                      style={{
                                        cursor: "pointer",
                                        color: "red",
                                      }}
                                      value="Delete"
                                    />
                                  </span>
                                </div>
                              ) : (
                                <div className="textLogo">{businessName}</div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Contact Person Name</td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            value={contactPersonName}
                            onChange={(e) =>
                              setContactPersonName(e.target.value)
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Contact Number</td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            value={contactNumber}
                            onChange={(e) => setContactNumber(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            value={businessEmail}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Pages</td>
                        <td>
                          <table className="table table-border table-striped table-bordered">
                            <tr>
                              <td>
                                <input
                                  style={{ transform: "scale(2)" }}
                                  type="checkbox"
                                  onChange={handleToggle}
                                  value="Home"
                                  checked={webPages.includes("Home")}
                                />
                              </td>
                              <td>Home Page</td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  style={{ transform: "scale(2)" }}
                                  type="checkbox"
                                  onChange={handleToggle}
                                  value="About"
                                  checked={webPages.includes("About")}
                                />
                              </td>
                              <td>About Us Page</td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  style={{ transform: "scale(2)" }}
                                  type="checkbox"
                                  onChange={handleToggle}
                                  value="Contact"
                                  checked={webPages.includes("Contact")}
                                />
                              </td>
                              <td>Contact Us Page</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      {webPages.includes("Home") && (
                        <tr>
                          <td>Home Page Content:</td>
                          <td>
                            <div style={{ height: 350 }}>
                              <ReactQuill
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                placeholder="Write your content..."
                                value={home}
                                onChange={(content) =>
                                  handleProcedureContentChange(content, "home")
                                }
                                style={{ height: "250px" }}
                              />
                            </div>
                          </td>
                        </tr>
                      )}
                      {webPages.includes("About") && (
                        <tr>
                          <td>About Us Page Content:</td>
                          <td>
                            <div style={{ height: 350 }}>
                              <ReactQuill
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                value={about}
                                placeholder="write your content ...."
                                onChange={(e) =>
                                  handleProcedureContentChange(e, "about-us")
                                }
                                style={{ height: "250px" }}
                              ></ReactQuill>
                            </div>
                          </td>
                        </tr>
                      )}
                      {webPages.includes("Contact") && (
                        <tr>
                          <td>Contact Us Page Content:</td>
                          <td>
                            <div style={{ height: 350 }}>
                              <ReactQuill
                                theme="snow"
                                style={{ height: "250px" }}
                                modules={modules}
                                formats={formats}
                                value={contactUs}
                                placeholder="write your content ...."
                                onChange={(e) =>
                                  handleProcedureContentChange(e, "contact")
                                }
                              ></ReactQuill>
                            </div>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td>Offering : </td>
                        <td>
                          <div className="form-group row">
                            <div className="col-sm-6">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="offering_type"
                                  value="products"
                                  onChange={handleChange}
                                  required
                                  checked={offering === "products"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="sleep-quality"
                                >
                                  Products Only
                                </label>
                              </div>

                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="offering_type"
                                  value="services"
                                  onChange={handleChange}
                                  required
                                  checked={offering === "services"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="cleanliness"
                                >
                                  Services Only
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="offering_type"
                                  value="both"
                                  onChange={handleChange}
                                  required
                                  checked={offering === "both"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="cleanliness"
                                >
                                  Both
                                </label>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      {(offering.includes("products") ||
                        offering.includes("both")) && (
                        <tr>
                          <td>Products</td>
                          <td>
                            <div className="card">
                              <table className="table table-border table-striped table-bordered">
                                <thead className="thead-dark">
                                  <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>Product Name</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan="4">
                                      <div className="form-group float-right">
                                        <button
                                          type="button"
                                          className="btn btn-primary m-2"
                                          onClick={(e) => {
                                            setAddProduct(true);
                                            setItemType("Product");
                                          }}
                                        >
                                          {products.length > 0
                                            ? "Add More Product"
                                            : "Add Product"}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                  {products.map((item, index) => (
                                    <tr id={index}>
                                      <td>{++index}</td>
                                      <td>
                                        {item.image === "" ? (
                                          <img
                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                                            height="80px"
                                            width="80px"
                                          ></img>
                                        ) : (
                                          <img
                                            src={item.image}
                                            alt={item.name}
                                            style={{
                                              maxWidth: "100%",
                                              maxHeight: "100px",
                                              display: "block",
                                            }}
                                          />
                                        )}
                                      </td>
                                      <td>{item.name}</td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-primary m-2"
                                          onClick={(e) => handleShow(item)}
                                        >
                                          View
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-warning m-2"
                                          onClick={(e) =>
                                            handleUpdateProduct(item)
                                          }
                                        >
                                          Update
                                        </button>

                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          aria-pressed="true"
                                          style={{ marginRight: "5px" }}
                                          onClick={(e) =>
                                            deleteRecord(
                                              item.productId,
                                              "Product",
                                              item.name
                                            )
                                          }
                                        >
                                          DELETE
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                      {(offering === "services" || offering === "both") && (
                        <tr>
                          <td>Services</td>
                          <td>
                            <div className="card">
                              <table className="table table-border table-striped table-bordered">
                                <thead className="thead-dark">
                                  <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>Service Name</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan="4">
                                      <div className="form-group float-right">
                                        <button
                                          type="button"
                                          className="btn btn-primary m-2"
                                          onClick={(e) => {
                                            setAddProduct(true);
                                            setItemType("Service");
                                          }}
                                        >
                                          {services.length > 0
                                            ? "Add More Service"
                                            : "Add Service"}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                  {services.map((item, index) => (
                                    <tr id={index}>
                                      <td>{++index}</td>
                                      <td>
                                        {item.image === "" ? (
                                          <img
                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                                            height="80px"
                                            width="80px"
                                          ></img>
                                        ) : (
                                          <img
                                            src={item.image}
                                            alt={item.name}
                                            style={{
                                              maxWidth: "100%",
                                              maxHeight: "100px",
                                              display: "block",
                                            }}
                                          />
                                        )}
                                      </td>
                                      <td>{item.name}</td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-primary m-2"
                                          onClick={(e) => handleShow(item)}
                                        >
                                          View
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-warning m-2"
                                          onClick={(e) =>
                                            handleUpdateProduct(item)
                                          }
                                        >
                                          Update
                                        </button>

                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          aria-pressed="true"
                                          style={{ marginRight: "5px" }}
                                          onClick={(e) =>
                                            deleteRecord(
                                              item.productId,
                                              "Service",
                                              item.name
                                            )
                                          }
                                        >
                                          DELETE
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="form-group float-right">
                    <Button type="submit" className="btn btn-primary btn-lg">
                      Save Changes
                    </Button>
                  </div>
                </form>
              )}
            </div>
          </main>
        </div>
      </div>

      <footer className="bg-body-tertiary text-center text-lg-start">
        <div
          className="text-center p-3"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
        >
          © 2025 Copyright:
          <a className="text-body" href="#">
            Casual Tech
          </a>
        </div>
      </footer>
      <Modal show={isUpdateProduct} onHide={handleProductClose} size="lg">
        <Modal.Header>
          <Modal.Title>Update Product</Modal.Title>
          <button
            type="button"
            className="btn-close m-2"
            onClick={handleProductClose}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="card p-5">
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-4">Product Name</div>
                <div className="input-group col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-4">Product Description</div>
                <div className="input-group col-sm-8">
                  <textarea
                    rows="5"
                    cols="33"
                    className="form-control"
                    value={productDesc}
                    onChange={(e) => setProductDesc(e.target.value)}
                    required
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-4">
                  Upload Product Image (Optional)
                </div>
                <div className="input-group col-sm-4">
                  <input
                    className="form-control"
                    type="file"
                    label="Image"
                    name="myFile"
                    accept=".jpeg, .png, .jpg"
                    onChange={(e) => handleFileUpload(e, "productImage")}
                  />
                </div>
                <div className="input-group col-sm-4">
                  {productImage === "" ? (
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100px",
                        display: "block",
                      }}
                    ></img>
                  ) : (
                    <img
                      src={productImage}
                      alt={productName}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100px",
                        display: "block",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleProductClose}
            className="m-2"
          >
            Close
          </Button>
          <Button variant="primary" onClick={updateProducts} className="m-2">
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header>
          <Modal.Title>View Detail : {productName}</Modal.Title>
          <button type="button" className="btn-close m-2" onClick={handleClose}>
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <div style={{ float: "left", padding: "0 10px 0 10px" }}>
            {productImage === "" ? (
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                height="80px"
                width="80px"
              ></img>
            ) : (
              <img
                src={productImage}
                alt={productName}
                style={{
                  maxWidth: "100%",
                  maxHeight: "500px",
                  display: "block",
                }}
              />
            )}
          </div>
          <div>
            <p>
              <h5>Description :</h5> {productDesc}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={addProduct} onHide={handleProductClose} size="lg">
        <Modal.Header>
          <Modal.Title>Add New {itemType}</Modal.Title>
          <button type="button" className="btn-close" onClick={handleProductClose}>
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="card p-5">
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-12">
                  <input
                    type="text"
                    className="form-control"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    required
                    placeholder={`${itemType} Name`}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-12">
                  <textarea
                    rows="5"
                    cols="33"
                    className="form-control"
                    value={productDesc}
                    onChange={(e) => setProductDesc(e.target.value)}
                    required
                    placeholder={`${itemType} Description`}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-4">
                  Upload {itemType} Image (Optional)
                </div>
                <div className="input-group col-sm-4">
                  <input
                    type="file"
                    label="Image"
                    name="myFile"
                    accept=".jpeg, .png, .jpg"
                    onChange={(e) => handleFileUpload(e, "productImage")}
                  />
                </div>
                <div className="input-group col-sm-4">
                  {productImage === "" ? (
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100px",
                        display: "block",
                      }}
                    ></img>
                  ) : (
                    <img
                      src={productImage}
                      alt={productName}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100px",
                        display: "block",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleProductClose}>
            Close
          </Button>
          <Button variant="primary" onClick={saveProduct}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <Footer />
    </>
  );
};

export default CompanyDetailUpdate;